module.exports = __webpack_public_path__ + "static/storm-rides-e65b7afd76b2c251a08b99eeba303c4e.png";